module.exports = __webpack_public_path__ + "img/roll-1530.c994ab8a.png";